import { Icon } from '@iconify/react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';
import { CompanyOption, fyStart, fyToDate, Range } from '../accounting.api';
import CompanySelect from './CompanySelect';

/** Title and company on one line (stacked on a phone), the screen's own controls below. */
export default function BooksHeader({
  title,
  companies,
  companyId,
  onCompany,
  loaded,
  action,
  children,
}: {
  title: string;
  companies: CompanyOption[];
  companyId: number | null;
  onCompany: (id: number) => void;
  loaded: boolean;
  action?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <Stack gap={2}>
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent='space-between' alignItems={{ sm: 'center' }} gap={1.5}>
        <Typography variant='subtitle1' fontSize='1rem' component='h2'>
          {title}
        </Typography>
        <Stack direction='row' gap={1} alignItems='center' flexWrap='wrap'>
          <CompanySelect companies={companies} value={companyId} onChange={onCompany} />
          {action}
        </Stack>
      </Stack>
      {loaded && companies.length === 0 && <Alert severity='warning'>No companies yet. An admin adds them in the Company Master.</Alert>}
      {children && (
        <Stack direction='row' gap={1.5} alignItems='center' flexWrap='wrap'>
          {children}
        </Stack>
      )}
    </Stack>
  );
}

/** From / To, with a shortcut back to the financial year to date. */
export function RangeFields({ value, onChange }: { value: Range; onChange: (r: Range) => void }) {
  return (
    <>
      <TextField
        label='From'
        type='date'
        size='small'
        value={value.from}
        onChange={(e) => onChange({ ...value, from: e.target.value })}
        InputLabelProps={{ shrink: true }}
        sx={{ width: 160 }}
      />
      <TextField
        label='To'
        type='date'
        size='small'
        value={value.to}
        onChange={(e) => onChange({ ...value, to: e.target.value })}
        InputLabelProps={{ shrink: true }}
        sx={{ width: 160 }}
      />
      <Tooltip title={`1 April ${fyStart().slice(0, 4)} to today`}>
        <Button size='small' startIcon={<Icon icon='mdi:calendar-range' />} onClick={() => onChange(fyToDate())}>
          This FY
        </Button>
      </Tooltip>
    </>
  );
}
